import { TFunction } from 'i18next';
import OrderStatus from './orderStatus';
import OrderType from './orderType';




export type OrderStatusesMap = Record<
    OrderType,
    Record<OrderStatus, string>
>;

export const getOrderStatuses = (t: TFunction): OrderStatusesMap => ({
    COURIER: {
        PROCESSING: t('orders.statuses.PROCESSING'),
        CANCELLED: t('orders.statuses.CANCELLED'),
        COOKING: t('orders.statuses.COOKING'),
        DONE: t('orders.statuses.DONE'),
        IN_PROGRESS: t('orders.statuses.IN_PROGRESS'),
        ON_WAY: t('orders.statuses.ON_WAY'),
        WAIT: t('orders.statuses.WAIT_COURIER'),
        AWAITING_PAYMENT: "Ожидает оплаты",
        PAYED: 'Оплачен'
    },
    GO_TO_PLACE: {
        PROCESSING: t('orders.statuses.PROCESSING'),
        CANCELLED: t('orders.statuses.CANCELLED'),
        COOKING: t('orders.statuses.COOKING'),
        DONE: t('orders.statuses.DONE'),
        IN_PROGRESS: t('orders.statuses.IN_PROGRESS'),
        ON_WAY: '',
        WAIT: t('orders.statuses.WAIT_GO_TO_PLACE'),
        AWAITING_PAYMENT: "Ожидает оплаты",
        PAYED: 'Оплачен'
    },
    IN_PLACE: {
        PROCESSING: t('orders.statuses.PROCESSING'),
        CANCELLED: t('orders.statuses.CANCELLED'),
        COOKING: t('orders.statuses.COOKING'),
        DONE: t('orders.statuses.DONE'),
        IN_PROGRESS: t('orders.statuses.IN_PROGRESS'),
        ON_WAY: '',
        WAIT: t('orders.statuses.WAIT_GO_TO_PLACE'),
        AWAITING_PAYMENT: "Ожидает оплаты",
        PAYED: 'Оплачен'
    },
});